<form [formGroup]="form">
    <section class="form-container">
        @if(userTypes.length > 1){
            <section class="form-user-type-container">
            <section class="user-type-container">
                <article class="user-type">
                    <div class="user-type-image">
                        <img src="../../assets/img/patient.svg" alt="patient">
                    </div>
                    <mat-radio-group formControlName="userType" name="userType">
                        <mat-radio-button [value]="userTypes[0].defaultWorkflow">
                            @if(form.get('userType')?.value === userTypes[0].defaultWorkflow){
                                <b>I'm a {{userTypes[0].display}}</b>
                            }
                            @else {
                                I'm a {{userTypes[0].display}}
                            }
                        </mat-radio-button>
                    </mat-radio-group>
                </article>
                <mat-divider [vertical]="true"></mat-divider>
                <article class = "user-type">
                    <div class="user-type-image">
                        <img src="../../assets/img/provider.svg" alt="provider">
                    </div>
                    <mat-radio-group formControlName="userType" name="userType">
                        <mat-radio-button [value]="userTypes[1].defaultWorkflow">
                            @if(form.get('userType')?.value === userTypes[1].defaultWorkflow){
                                <b>I'm a {{userTypes[1].display}}</b>
                            }
                            @else {
                                I'm a {{userTypes[1].display}}
                            }
                        </mat-radio-button>
                    </mat-radio-group>
                </article>
            </section>
            @if(form.get('userType')?.touched && form.get('userType')?.hasError('required')){
                <div class="form-error recaptcha-error">
                    <mat-icon class="error-icon" aria-label="error" fontIcon="error"></mat-icon>
                      Select the user type
                </div>
            }
           </section>
        }
        <!-- @if(userTypes.length === 1 || form.get('userType')?.value){
        <section class="program-product-container" data-testid="programProductSelection">
            @if(!(programProductConfig.length === 1 && hideSingleOptions)){
                <label for="program" class="form-field-header">Select the Program</label>
                <mat-form-field data-testid="program" class="form-field density-2">
                    <mat-select formControlName="program" placeholder="--Select--">
                        @for(item of programProductConfig; track $index;){
                            <mat-option [value]="item.program">{{item.program}}</mat-option>
                        }
                    </mat-select>
                    @if(form.get('program')?.hasError('required')){
                        <mat-error class="form-error">
                            <mat-icon aria-label="error" fontIcon="error" class="error-icon"></mat-icon>
                            Select a program
                        </mat-error>
                    }
                </mat-form-field>
            }
            @if(!(selectedProgramConfig.products.length === 1 && hideSingleOptions)){
                <label for="product" class="form-field-header">Select the Product</label>
                <mat-form-field data-testid="product" class="form-field density-2">
                    @if(selectedProgramConfig.allowMultipleProductSelection){
                        <mat-select formControlName="product" placeholder="--Select--" multiple>
                            @for(product of selectedProgramConfig.products; track $index){
                                <mat-option [value]="product">{{product.display}}</mat-option>
                            }
                        </mat-select>
                    }
                    @else{
                        <mat-select formControlName="product" placeholder="--Select--">
                            @for(product of selectedProgramConfig.products; track $index){
                                <mat-option [value]="product">{{product.display}}</mat-option>
                            }
                        </mat-select>
                    }
                    @if(form.get('product')?.hasError('required')){
                        <mat-error class="form-error">
                            <mat-icon aria-label="error" fontIcon="error" class="error-icon"></mat-icon>
                            @if(!form.get('program')?.value){
                                Select a program to view products
                            }
                            @else {
                                Select a product
                            }
                        </mat-error>
                    }
                </mat-form-field>
            }
        </section>
        } -->

        <div class="recaptcha">
            <re-captcha formControlName="recaptcha"></re-captcha>
        </div>
        @if(form.get('recaptcha')?.hasError('required') && form.get('recaptcha')?.touched){
            <div class="form-error recaptcha-error">
                <mat-icon aria-label="error" fontIcon="error" class="error-icon"></mat-icon>
                <span class="error-message">Recaptcha Required</span>
              </div>
        }

        <section class="button-container">
            <button mat-flat-button color="primary" data-testid="begin" class="login-button" (click)="begin()">Begin</button>
        </section>
    </section>
  </form>
